<template>
	<div class="colHalf rubric">
		<div v-if="title" :class="`row between rubricTitle cat${categoryId}`">
				<span>{{title}}</span>
				<span>{{parseInt(percentage)}}%</span>
		</div>
		<div class="row ml-2 mt-2">
			<chart :properties="chartProperties" width="100%" height="40%"></chart>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';

export default {
	props: ['data', 'title', 'percentage', 'categoryId', 'legend'],
	computed: {
		chartColors () {
			if (this.categoryId == 1) return {background: 'rgba(161, 142, 191, 0.4)', border: 'rgba(161, 142, 191, 1)'};
			else if (this.categoryId == 2) return {background: 'rgba(46, 162, 225, 0.4)', border: 'rgba(46, 162, 225, 1)'};
			else if (this.categoryId == 3) return {background: 'rgba(41, 180, 179, 0.4)', border: 'rgba(41, 180, 179, 1)'};
			else if (this.categoryId == 4) return {background: 'rgba(253, 170, 114, 0.4)', border: 'rgba(253, 170, 114, 1)'};
			else return {background: 'rgba(74, 144, 226, 0.45)', border: 'rgba(74, 144, 226, 1)'};
		},
		chartProperties () {
			return {
				type: 'line',
				data: {
					labels: this.data.labels,
					datasets: this.data.datasets.map((dataset) => {
						if (!dataset.backgroundColor) dataset.backgroundColor = this.chartColors.background;
						if (!dataset.borderColor) dataset.borderColor = this.chartColors.border;
						return dataset;
					})
				},
				options: {
					legend: {
						display: this.legend
					},
					tooltips: {
						enabled: true,
						displayColors: false,
						position: 'nearest',
						titleFontColor: 'black',
						backgroundColor: this.chartColors.background,
						borderColor: this.chartColors.border,
						bodyFontColor: 'black',
						borderWidth: 2,
						cornerRadius: 2,
						caretSize: 10,
						defaultFontSize: 12,
						yPadding: 10,
						xPadding: 10,
						callbacks: {
							title: function (tooltipItem, data) {
								return `${data.datasets[tooltipItem[0].datasetIndex].dates[tooltipItem[0].index]}`;
							},
							label: function (tooltipItem) {
								return `${tooltipItem.yLabel}%`;
							},
							afterLabel: function (tooltipItem, data) {
								if (tooltipItem.index === 0) return '';
								let previousValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index - 1];
								let difference = tooltipItem.yLabel - previousValue;
								let progress = (parseInt(difference) * 100) / parseInt(previousValue);
								return difference <= 0 ? (difference == 0 ? `${-1 * parseInt(progress)}% ` : `- ${-1 * parseInt(progress)}% `) : `+ ${parseInt(progress)}% `;
							}
						}
					},
					scales: {
						xAxes: [{
							gridLines: {
								color: 'rgba(81, 95, 122, 0.2)',
								lineWidth: 1
							}
						}],
						yAxes: [{
							ticks: {
								display: true,
								beginAtZero: true,
								max: 100,
								stepSize: 25
							},
							gridLines: {
								color: 'rgba(81, 95, 122, 0.2)',
								lineWidth: 1
							}
						}]
					}
				}
			};
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "../../scss/global.scss";

.rubric {
	margin: 2rem 0;
	&Title {
		font-size: $largeSize;
		color: $oxfordBlue;
		font-weight: 700;
		width: 98%;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/ui/ProgressChart.vue